import { faro, type LogContext } from '@grafana/faro-react'
import { configureLogger } from '@simplisafe/compass-web'
import { getFaroSessionId } from '../../faro/faroSession'
import { devLogLevels } from './devLogLevels'
import type { LoggerName } from './LoggerName'
import { prodLogLevels } from './prodLogLevels'

/**
 * Shared context attached to every Faro log so entries can be correlated to the page and session
 * they came from. The session id is sourced from the module-level holder that
 * AuthenticationContextProvider populates, so every leveled log line and error carries it.
 */
function addToFaroContext(): LogContext {
  return {
    path: window.location.pathname,
    sessionId: getFaroSessionId()
  }
}


export const namedLogger = configureLogger<typeof LoggerName>({
  appName: 'admin-review-tool-react',
  logLevels: import.meta.env.PROD ? prodLogLevels : devLogLevels,
  enableLoggingToConsole: import.meta.env.DEV,
  faroConfig: dex.config.faro?.enabled ? { faroInstance: faro, addToFaroContext } : undefined
})
